import { SavedNote } from '@/types'
import { httpClient } from './httpClient'

interface GetStNotesRequestPayload {
  scheduleId: number
}

interface AddStNotesRequestPayload {
  scheduleId: number
  notes: {
    text: string
    order: number
  }[]
}

interface DeleteStNotePayload {
  scheduleId: number
  noteIds: number[]
}

interface EditStNotePayload {
  scheduleId: number
  notes: { id: number; text?: string; order?: number }[]
}

export async function getStNotes ({
  scheduleId
}: GetStNotesRequestPayload): Promise<SavedNote[]> {
  try {
    let url = import.meta.env.VITE_SCHEDULE_TPL_GET_NOTES_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'GET',
      withCredentials: true,
      cache: false
    })

    if (!response) throw Error

    return response.data
  } catch (error) {
    console.error('getStNotes - Error: ', error)
    throw error
  }
}

export async function addBatchStNote ({ scheduleId, notes }: AddStNotesRequestPayload) {
  try {
    let url = import.meta.env.VITE_BATCH_SCHEDULE_ADD_TPL_NOTE_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'POST',
      withCredentials: true,
      suppressErrorNotification: true,
      data: {
        notes
      }
    })

    if (!response) throw Error

    return response
  } catch (error) {
    console.error('addBatchStNote - Error: ', error)
    throw error
  }
}

export async function deleteBatchStNote ({
  scheduleId,
  noteIds
}: DeleteStNotePayload) {
  try {
    let url = import.meta.env.VITE_BATCH_DELETE_TPL_NOTES_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'DELETE',
      withCredentials: true,
      suppressErrorNotification: true,
      data: { noteIds }
    })

    if (!response) throw Error

    return response
  } catch (error: any) {
    console.error('deleteBatchStNote - Error: ', error)
    throw error
  }
}

export async function editBatchStNote ({
  scheduleId,
  notes
}: EditStNotePayload) {
  try {
    let url = import.meta.env.VITE_BATCH_SCHEDULE_TPL_UPDATE_NOTE_ENDPOINT
    url = url.replace('__scheduleId__', scheduleId.toString())

    const response = await httpClient({
      baseURL: import.meta.env.VITE_API_MAIN_BASEURL,
      url,
      method: 'PUT',
      data: {
        notes
      },
      suppressErrorNotification: true,
      withCredentials: true
    })

    if (!response) throw Error

    return response
  } catch (error: any) {
    console.error('editBatchStNote - Error: ', error)
    throw error
  }
}
